import type { CreateAxiosDefaults } from 'axios'

import { getApiUrl, SHORT_API_TIMEOUT } from '~sharedConfig'
import { ApiSourceType } from '~sharedLib'

export const baseConfig = (sourceType: ApiSourceType): CreateAxiosDefaults => {
	const BASE_URL = getApiUrl(sourceType) as string

	return {
		baseURL: BASE_URL,
		timeout: SHORT_API_TIMEOUT,
		headers: {
			'Content-Type': 'application/json'
		}
	}
}
